// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"11":"0d958eb54cedb566","1435":"eda26ca7cdc30f0e","4538":"921febb913f93f62","8513":"c2daee9082847870"}[chunkId] + ".css";
};